import React, { useState, useEffect } from "react";
import { getAnalytics } from "firebase/analytics";
import { Link } from "react-router-dom";
import { gsap } from "gsap";

export default function Footer() {
  const [shouldShowPopup, setShouldShowPopup] = useState(true);
  const cookieStorage = {
    getItem: (key) => {
      const cookies = document.cookie
        .split(";")
        .map((cookie) => cookie.split("="))
        .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
      return cookies[key];
    },
    setItem: (key, value) => {
      document.cookie = `${key}=${value}; max-age=15552000`;
    },
  };

  const storageType = cookieStorage;
  const consentPropertyName = "bejour_consent";
  const saveToStorageTrue = () => storageType.setItem(consentPropertyName, true);
  const saveToStorageFalse = () => storageType.setItem(consentPropertyName, false);

  useEffect(() => {
    if (!storageType.getItem(consentPropertyName)) {
      //setShouldShowPopup(true);
      let tl_consent = gsap.timeline();
      tl_consent.fromTo(
        "#consent-popup",
        { autoAlpha: 0, y: 20 },
        { autoAlpha: 1, y: 0, duration: 0.8, delay: 0.3 }
      );
      return () => {
        tl_consent.kill();
      };
    }
  }, [storageType]);

  function handleAccept() {
    saveToStorageTrue();
    getAnalytics();
    setShouldShowPopup(false);
  }

  function handleDecline() {
    saveToStorageFalse();
    setShouldShowPopup(false);
  }

  return (
    <>
      <div className="footer-container">
        <div className="legal-container">
          <div>
            <a
              className="legal-link"
              href="https://dispassion.blog/"
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
          </div>
          <div>
            <Link className="legal-link" to="/privacy">
              Privacy Policy
            </Link>
          </div>
          <div>
            <Link className="legal-link" to="/imprint">
              Imprint
            </Link>
          </div>
        </div>
        <div className="by-text">Developed and designed by Thomas Moser</div>
      </div>
      {shouldShowPopup && (
        <div id="consent-popup">
          <p>
            We use cookies to improve this site and your experience on it. Read more in our{" "}
            <Link className="consent-link" to="/privacy">
              Privacy Policy
            </Link>
          </p>
          <div className="consent-btn-container">
            <div id="consent-accept-btn" className="consent-btn btn" onClick={handleAccept}>
              Accept
            </div>
            <div
              id="consent-decline-btn"
              className="consent-btn btn btn-sec"
              onClick={handleDecline}
            >
              Decline
            </div>
          </div>
        </div>
      )}
    </>
  );
}
